<div class="flex flex-col gap-2.5 h-full">
  <!-- Sustainability Page Header -->
  <div class="hidden tb:block">
    <app-sustainability-entry-header
      [selectedYear]="selectedYear"
      [selectedMonth]="selectedMonth"
      (yearSelected)="onYearSelectedFromHeader($event)"
      (monthSelected)="onMonthSelectedFromHeader($event)"
      (entryAdded)="handleNewEntries($event)"
      (saveSuccessful)="onSaveSuccess()"
       [editedEntries]="editedRows"
      [isSaveEnabled]="isSaveEnabled"
      [selectedTravelIds]="selectedTravelIds"
      [isSelectedforDeletion]="isSelectedforDeletion"
      [isFlagSubmitted]="isFlagSubmitted"
      [rowData]="allRows"
      (selectedTravelIdsChanged)="onSelectedTravelIdsChanged($event)"
      (rowSelectionChanged)="onRowSelectionChanged($event)"
      (travelIdsDeleted)="onTravelIdsDeleted($event)"
      (yearMonthSelectionChanged)="onYearMonthSelectionChange($event)"
      (resetTriggered)="onResetTriggered()"
      (newRowsSaved)="onNewRowsSaved($event)"
      (copiedRowAdded)="onCopiedRowAdded($event)"
      (previousMonthCopied)="copyPreviousMonthEntries()"

      [chartData]="formattedChartData"
      [entryPageType]="entryPageType">
    </app-sustainability-entry-header>
  </div>
  <!-- Table -->
  <div class="h-full">
    <app-sustainability-entry-table
      (rowModified)="onRowModified()"
      [selectedYearMonthPairs]="selectedYearMonthPairs"
      [selectedYear]="selectedYear"
      [selectedMonth]="selectedMonthNum"
      [isFlagSubmitted]="isFlagSubmitted"
      [isLoading]="isLoading"
      (monthSelected)="onMonthSelectedFromTable($event)"
      (selectedTravelIdsChanged)="onSelectedTravelIdsChanged($event)"
      (rowSelectionChanged)="onRowSelectionChanged($event)"
      (travelIdsDeleted)="onRowsDeletedFromChild($event)"
      (newRowCreated)="onNewRowCreated($event)"
      (rowEdited)="onRowEdited($event)"
      (flagCompletionDeleted)="onFlagCompletionDeleted($event)"
      [rowData]="displayedRows">
    </app-sustainability-entry-table>
  </div>

  <!-- Chart Component -->
  <!-- <div class="mt-4">
    <app-sustainability-chart 
  [formattedData]="allRows"></app-sustainability-chart>
  </div> -->
</div>
